// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"Header_mainHeader__IlbE3","mainHeaderUnicorn":"Header_mainHeaderUnicorn__1OWT2","green":"Header_green__1Ib-x"};